// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge-container{border-radius:4px;display:inline-block;font-family:\"Inter\",sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:18px;padding:0 6px}.badge-container+.badge-container{margin-left:4px}.blue{background:#39f;color:#e6f3ff}.yellow{background:#ffd644;color:#524d40}.orange{background:#ff9239;color:#fff5ec}@media only screen and (max-width:1363px){.badge-container+.badge-container{margin-left:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
